import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1017cf88"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ion-text-wrap ion-text-center"
};
const _hoisted_2 = {
  key: 1,
  class: "ion-text-wrap ion-text-center"
};
const _hoisted_3 = {
  class: "resources-message-header"
};
const _hoisted_4 = {
  class: "resources-message-header"
};
const _hoisted_5 = {
  class: "ion-padding-horizontal"
};
const _hoisted_6 = {
  class: "ion-padding-horizontal"
};
const _hoisted_7 = {
  class: "ion-padding-horizontal"
};
import { IonContent, IonicSlides, modalController } from '@ionic/vue';
import { useDebounceFn } from '@vueuse/shared';
import { useMachine } from '@xstate/vue';
import { Pagination } from 'swiper/modules';
import { Swiper as VueSwiper, SwiperSlide } from 'swiper/vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { createMachine } from 'xstate';
import Router, { RESOURCES_PATH } from '@/router';
import ColumbiaSelfReportFormResourceItem from '@/components/ColumbiaSelfReportFormResourceItem.vue';
import useColumbiaSelfReport from '@/composables/global/use-columbia-self-report';
import { errorAlert } from '@/utils/ion-alert';
import { resourcesMessageSafetyCard } from '@/data/c-ssrs-safety-card';
import 'swiper/css';
import 'swiper/css/pagination';
export default /*#__PURE__*/_defineComponent({
  __name: 'ColumbiaSelfReportForm',
  props: {
    userId: {}
  },
  setup(__props) {
    const columbiaSelfReportMachine = createMachine({
      predictableActionArguments: true,
      id: 'columbiaSelfReportForm',
      initial: 'ready',
      states: {
        ready: {
          on: {
            COMPLETED: 'completed'
          }
        },
        completed: {
          on: {
            SAVE: 'saving'
          }
        },
        saving: {
          on: {
            SAVED: 'thankYou',
            ERROR: 'completed'
          }
        },
        thankYou: {
          on: {
            THANKED: 'resources'
          }
        },
        resources: {
          type: 'final'
        }
      }
    });
    const props = __props;
    const {
      locale,
      t
    } = useI18n({
      messages: {
        en: {
          headerPrompt: 'In the past month',
          recentHeaderPrompt: 'Since the last time you completed this questionnaire',
          formQuestions: ['Have you wished you were dead or wished you could go to sleep and not wake up?', 'Have you actually had any thoughts of killing yourself?', 'Have you thought about how you might do this?', 'Have you had any intention of acting on these thoughts of killing yourself, as opposed to you have the thoughts, but you definitely would not act on them?', 'Have you started to work out, or actually worked out, the spesific details of how to kill yourself and did you actually intend to carry out the details of your plan?', 'Have you ever done anything, started to do anything, or prepared to do anything to end your life?'],
          formExamples: ['', '', 'For example, "I thought about taking an overdose but I never worked out the details about when, where, and how I would do that and I would never act on these thoughts."', 'For example, "I had the thought of killing myself by taking an overdose and am not sure whether I would do it or not."', 'For example, "I am planning to take 3 bottles of my sleep medication this Saturday when no one is around to stop me."', 'For example: Collected pills, obtained a gun, gave away valuables, wrote a will or suicide note, took out pills but didnt swallow any, held a gun but changed your mind about hurting yourself or it was grabbed from your hand, went to the roof to jump but didnt; or actually took pills, tried to shoot yourself, cut yourself, tried to hang yourself, etc.'],
          response: ['Yes', 'No'],
          selfReportRecentQuestion: 'Did this occur in the past 3 months?',
          skipButton: 'skip question',
          submitButton: 'Submit',
          thankYou: 'Thank you for responding',
          resourcesMessage: {
            resourcesMessageTitle: ['Your responses indicate that you recently had thoughts about self-harm. We care about you.', 'Mom-Net is not a crisis service and your coach is not a mental health professional. However, you can use the safety reminder card below to take the steps you need to move toward safety right now.'],
            goingOn: "What's Going On?",
            whatDo: 'What Do I Do?',
            resourcesAvailability: 'These resources are available to view again from the Resources page under General Resources - National.',
            linkToResources: 'Go to Resources',
            momNetTeam: 'The Mom-Net Team'
          }
        },
        es: {
          headerPrompt: 'Durante la última mes',
          recentHeaderPrompt: 'Desde la última vez que usted rellenó este cuestionario',
          formQuestions: ['¿Ha deseado estar muerto(a) o poder dormirse y no despertar?', '¿Ha tenido realmente la idea de suicidarse?', '¿Ha pensado en cómo llevaría esto a cabo?', '¿Ha tenido estas ideas y en cierto grado la intención de llevarlas a cabo?', '¿Ha comenzado a elaborar o ha elaborado los detalles sobre cómo suicidarse? ¿Tenída intenciones de llevar a cabo este plan?', '¿Ha hecho algo usted, comenzado a hacer algo o se has preparado para hacer algo para terminar su vida?'],
          formExamples: ['', '', 'Esto incluye a un(a) participante que diría: “He tenido la idea de tomar una sobredosis, pero nunca hice un plan específico sobre el momento, el lugar o cómo lo haría realmente… y nunca lo haría”.', 'A diferencia de “Tengo los pensamientos, pero definitivamente no haré nada al respecto”.', '', 'Ejemplos: Colectar píldoras, obtener una arma, regalar cosas de valor, escribir un testamento o carta de suicidio, sacado píldoras de la botella pero no las tragado, agarrar una arma pero ha cambiado de mente de usarla o alguien se la ha quitado de sus manos, ha subido al techo pero no ha saltado al vació;  o realmente ha tomado píldoras, ha tratado de disparar una arma, se ha cortado, ha tratado de colgarse, etc.'],
          response: ['Sí', 'No'],
          selfReportRecentQuestion: '¿Ha ocurrido en los últimos 3 meses?',
          skipButton: 'omitir pregunta',
          submitButton: 'Enviar',
          thankYou: 'Gracias por responder',
          resourcesMessage: {
            resourcesMessageTitle: ['Sus respuestas indican que recientemente ha pensado en autolesionarse. Nos preocupamos por usted.', 'Mom-Net no es un servicio de crisis y su tutor no es un profesional de la salud mental. Sin embargo, puede utilizar la tarjeta de recordatorio de seguridad que aparece a continuación para tomar las medidas necesarias para avanzar hacia la seguridad ahora mismo.'],
            goingOn: '¿Qué está pasando?',
            whatDo: '¿Qué debo hacer?',
            resourcesAvailability: 'Estos recursos pueden consultarse de nuevo en la página de Recursos, en Recursos generales - Nacional',
            linkToResources: 'Ir a Recursos',
            momNetTeam: 'El equipo de Mom-Net'
          }
        }
      }
    });
    const {
      columbiaSelfReportVersion,
      addColumbiaSelfReport
    } = useColumbiaSelfReport();
    const {
      state,
      send
    } = useMachine(columbiaSelfReportMachine);
    const modules = [Pagination, IonicSlides];
    const ionContentRef = ref();
    const slidesRef = ref();
    const hasSelfReportRecentQuestion = ref(false);
    function setSwiperInstance(swiper) {
      slidesRef.value = swiper;
    }
    const responses = ref({});
    const questionsToAsk = ref([{
      num: 0,
      title: 'q1'
    }, {
      num: 1,
      title: 'q2'
    }, {
      num: 2,
      title: 'q3'
    }, {
      num: 3,
      title: 'q4'
    }, {
      num: 4,
      title: 'q5'
    }, {
      num: 5,
      title: 'q6'
    }]);
    const debouncedSlideNext = useDebounceFn(() => {
      var _slidesRef$value;
      (_slidesRef$value = slidesRef.value) === null || _slidesRef$value === void 0 || _slidesRef$value.slideNext();
    }, 500);
    function dismiss() {
      modalController.dismiss({}, undefined, 'columbiaForm');
    }
    function navToResources() {
      dismiss();
      Router.push(RESOURCES_PATH).catch(error => {
        errorAlert({
          error
        });
      });
    }
    function thankYou() {
      setTimeout(() => {
        send('THANKED');
      }, 2000);
    }
    function scrollBack() {
      var _slidesRef$value2, _ionContentRef$value;
      (_slidesRef$value2 = slidesRef.value) === null || _slidesRef$value2 === void 0 || _slidesRef$value2.slidePrev();
      (_ionContentRef$value = ionContentRef.value) === null || _ionContentRef$value === void 0 || _ionContentRef$value.$el.scrollToTop();
    }
    function selectResponse(question, response) {
      responses.value[question.title] = response;
      switch (question.num) {
        case 1:
          if (response === 'No' || response === 'Skipped') {
            questionsToAsk.value = [{
              num: 0,
              title: 'q1'
            }, {
              num: 1,
              title: 'q2'
            }, {
              num: 5,
              title: 'q6'
            }];
          } else {
            questionsToAsk.value = [{
              num: 0,
              title: 'q1'
            }, {
              num: 1,
              title: 'q2'
            }, {
              num: 2,
              title: 'q3'
            }, {
              num: 3,
              title: 'q4'
            }, {
              num: 4,
              title: 'q5'
            }, {
              num: 5,
              title: 'q6'
            }];
          }
          break;
        case 5:
          if (columbiaSelfReportVersion.value === 'Self Report Recent' && response === 'Yes') {
            hasSelfReportRecentQuestion.value = true;
            return;
          } else {
            send('COMPLETED');
            hasSelfReportRecentQuestion.value = false;
            break;
          }
        case 6:
          send('COMPLETED');
          break;
      }
      debouncedSlideNext();
    }
    async function submitForm() {
      send('SAVE');
      try {
        responses.value.version = columbiaSelfReportVersion.value;
        await addColumbiaSelfReport(responses.value, props.userId);
        thankYou();
      } catch (error) {
        errorAlert({
          error
        });
        send('ERROR');
      } finally {
        send('SAVED');
      }
    }
    return (_ctx, _cache) => {
      const _component_ion_title = _resolveComponent("ion-title");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_toolbar = _resolveComponent("ion-toolbar");
      const _component_ion_header = _resolveComponent("ion-header");
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_item = _resolveComponent("ion-item");
      const _component_ion_col = _resolveComponent("ion-col");
      const _component_ion_row = _resolveComponent("ion-row");
      const _component_ion_grid = _resolveComponent("ion-grid");
      const _component_ion_list = _resolveComponent("ion-list");
      const _component_ion_radio = _resolveComponent("ion-radio");
      const _component_ion_radio_group = _resolveComponent("ion-radio-group");
      const _component_ion_spinner = _resolveComponent("ion-spinner");
      const _component_ion_footer = _resolveComponent("ion-footer");
      const _component_ion_page = _resolveComponent("ion-page");
      return _openBlock(), _createBlock(_component_ion_page, null, {
        default: _withCtx(() => [_createVNode(_component_ion_header, null, {
          default: _withCtx(() => [_createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [!(_unref(state).matches('thankYou') || _unref(state).matches('resources')) ? (_openBlock(), _createBlock(_component_ion_title, {
              key: 0,
              class: "ion-padding modal-title",
              color: "toolbar-text"
            }, {
              default: _withCtx(() => [_unref(columbiaSelfReportVersion) === 'Self Report Since Last Visit' ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)('recentHeaderPrompt')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('headerPrompt')), 1))]),
              _: 1
            })) : _createCommentVNode("", true), _unref(state).matches('resources') ? (_openBlock(), _createBlock(_component_ion_buttons, {
              key: 1,
              slot: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                onClick: dismiss
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: "close"
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(IonContent), {
          ref_key: "ionContentRef",
          ref: ionContentRef
        }, {
          default: _withCtx(() => [_unref(state).matches('thankYou') ? (_openBlock(), _createBlock(_component_ion_label, {
            key: 0,
            class: "ion-padding ion-text-center slide-thank-you-text"
          }, {
            default: _withCtx(() => [_createElementVNode("h1", null, _toDisplayString(_unref(t)('thankYou')), 1), _createVNode(_component_ion_icon, {
              name: "checkmark",
              size: "large",
              color: "primary"
            })]),
            _: 1
          })) : _createCommentVNode("", true), _unref(state).matches('resources') ? (_openBlock(), _createBlock(_component_ion_list, {
            key: 1,
            class: "ion-padding"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1], index => {
              return _createVNode(_component_ion_item, {
                lines: "none",
                key: index
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_label, {
                  class: "ion-text-wrap"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`resourcesMessage.resourcesMessageTitle[${index}]`)), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024);
            }), 64)), _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [_createVNode(_component_ion_row, {
                class: "header-row"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_col, {
                  class: "header-col",
                  size: "6"
                }, {
                  default: _withCtx(() => [_createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('resourcesMessage.goingOn')), 1)]),
                  _: 1
                }), _createVNode(_component_ion_col, {
                  class: "header-col",
                  size: "6"
                }, {
                  default: _withCtx(() => [_createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('resourcesMessage.whatDo')), 1)]),
                  _: 1
                })]),
                _: 1
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resourcesMessageSafetyCard), (message, index) => {
                return _openBlock(), _createBlock(_component_ion_row, {
                  class: _normalizeClass([{
                    'severity-high': message.severity === 'high',
                    'severity-medium': message.severity === 'medium',
                    'severity-low': message.severity === 'low'
                  }, "content-row"]),
                  key: index
                }, {
                  default: _withCtx(() => [_createVNode(_component_ion_col, {
                    size: "6",
                    class: "ion-text-start"
                  }, {
                    default: _withCtx(() => [_createVNode(ColumbiaSelfReportFormResourceItem, {
                      severity: message.severity,
                      headerList: _unref(locale) === 'es' ? message.goingOn.headerEs : message.goingOn.header,
                      bulletList: _unref(locale) === 'es' ? message.goingOn.bulletsEs : message.goingOn.bullets
                    }, null, 8, ["severity", "headerList", "bulletList"])]),
                    _: 2
                  }, 1024), _createVNode(_component_ion_col, {
                    size: "6",
                    class: "ion-text-start"
                  }, {
                    default: _withCtx(() => [_createVNode(ColumbiaSelfReportFormResourceItem, {
                      severity: message.severity,
                      headerList: _unref(locale) === 'es' ? message.whatDo.headerEs : message.whatDo.header,
                      bulletList: _unref(locale) === 'es' ? message.whatDo.bulletsEs : message.whatDo.bullets
                    }, null, 8, ["severity", "headerList", "bulletList"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["class"]);
              }), 128))]),
              _: 1
            }), _createVNode(_component_ion_item, {
              lines: "none"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_label, {
                class: "ion-text-wrap"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('resourcesMessage.resourcesAvailability')), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_ion_item, {
              lines: "none"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                fill: "clear",
                color: "primary",
                onClick: navToResources
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_label, {
                  class: "ion-text-wrap"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('resourcesMessage.linkToResources')), 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_ion_item, {
              lines: "none"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_label, {
                class: "ion-text-wrap"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('resourcesMessage.momNetTeam')), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : (_openBlock(), _createBlock(_unref(VueSwiper), {
            key: 2,
            onSwiper: setSwiperInstance,
            modules: modules,
            pagination: "",
            class: "swiper-no-swiping swiper-slides"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionsToAsk.value, question => {
              return _openBlock(), _createBlock(_unref(SwiperSlide), {
                key: question.num,
                class: "swiper-slide"
              }, {
                default: _withCtx(() => {
                  var _slidesRef$value3, _slidesRef$value5;
                  return [_createVNode(_component_ion_list, {
                    class: "swiper-slide-content"
                  }, {
                    default: _withCtx(() => [_createElementVNode("h4", _hoisted_5, [_createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`formQuestions[${question.num}]`)), 1)]),
                      _: 2
                    }, 1024)]), _createElementVNode("h5", _hoisted_6, [_createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`formExamples[${question.num}]`)), 1)]),
                      _: 2
                    }, 1024)]), question.num !== 6 ? (_openBlock(), _createBlock(_component_ion_radio_group, {
                      key: 0
                    }, {
                      default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Yes', 'No'], (response, index) => {
                        return _createVNode(_component_ion_item, {
                          key: response,
                          lines: "none",
                          onClick: $event => selectResponse(question, response)
                        }, {
                          default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`response[${index}]`)), 1)]),
                            _: 2
                          }, 1024), _createVNode(_component_ion_radio, {
                            slot: "start",
                            value: response
                          }, null, 8, ["value"])]),
                          _: 2
                        }, 1032, ["onClick"]);
                      }), 64))]),
                      _: 2
                    }, 1024)) : _createCommentVNode("", true)]),
                    _: 2
                  }, 1024), hasSelfReportRecentQuestion.value && question.num === 5 ? (_openBlock(), _createBlock(_component_ion_list, {
                    key: 0,
                    class: "swiper-slide-content"
                  }, {
                    default: _withCtx(() => [_createElementVNode("h4", _hoisted_7, [_createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`selfReportRecentQuestion`)), 1)]),
                      _: 1
                    })]), _createVNode(_component_ion_radio_group, null, {
                      default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Yes', 'No'], (response, index) => {
                        return _createVNode(_component_ion_item, {
                          key: response,
                          onClick: $event => selectResponse({
                            num: 6,
                            title: 'q6b'
                          }, response),
                          lines: "none"
                        }, {
                          default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`response[${index}]`)), 1)]),
                            _: 2
                          }, 1024), _createVNode(_component_ion_radio, {
                            slot: "start",
                            value: response
                          }, null, 8, ["value"])]),
                          _: 2
                        }, 1032, ["onClick"]);
                      }), 64))]),
                      _: 1
                    })]),
                    _: 1
                  })) : _createCommentVNode("", true), _createVNode(_component_ion_button, {
                    class: "block-centered",
                    onClick: $event => selectResponse(question, 'Skipped'),
                    fill: "clear",
                    size: "small"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('skipButton')), 1)]),
                    _: 2
                  }, 1032, ["onClick"]), !((_slidesRef$value3 = slidesRef.value) !== null && _slidesRef$value3 !== void 0 && _slidesRef$value3.isEnd) ? (_openBlock(), _createBlock(_component_ion_label, {
                    key: 1,
                    class: "slide-foot-note ion-padding"
                  }, {
                    default: _withCtx(() => {
                      var _slidesRef$value$acti, _slidesRef$value4;
                      return [_createTextVNode(_toDisplayString(`${((_slidesRef$value$acti = (_slidesRef$value4 = slidesRef.value) === null || _slidesRef$value4 === void 0 ? void 0 : _slidesRef$value4.activeIndex) !== null && _slidesRef$value$acti !== void 0 ? _slidesRef$value$acti : 0) + 1} / ${questionsToAsk.value.length}`), 1)];
                    }),
                    _: 1
                  })) : _createCommentVNode("", true), (_slidesRef$value5 = slidesRef.value) !== null && _slidesRef$value5 !== void 0 && _slidesRef$value5.isEnd && _unref(state).matches('completed') ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 2,
                    disabled: _unref(state).matches('saving'),
                    onClick: submitForm,
                    expand: "block",
                    class: "ion-margin-top base-margin"
                  }, {
                    default: _withCtx(() => [_unref(state).matches('saving') ? (_openBlock(), _createBlock(_component_ion_spinner, {
                      key: 0
                    })) : (_openBlock(), _createBlock(_component_ion_label, {
                      key: 1
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('submitButton')), 1)]),
                      _: 1
                    }))]),
                    _: 1
                  }, 8, ["disabled"])) : _createCommentVNode("", true)];
                }),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          }))]),
          _: 1
        }, 512), _createVNode(_component_ion_footer, null, {
          default: _withCtx(() => {
            var _slidesRef$value6;
            return [((_slidesRef$value6 = slidesRef.value) === null || _slidesRef$value6 === void 0 ? void 0 : _slidesRef$value6.activeIndex) !== 0 && !(_unref(state).matches('thankYou') || _unref(state).matches('resources')) ? (_openBlock(), _createBlock(_component_ion_item, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = $event => scrollBack()),
              lines: "none"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_icon, {
                class: "icon",
                size: "large",
                icon: "arrow-back"
              })]),
              _: 1
            })) : _createCommentVNode("", true)];
          }),
          _: 1
        })]),
        _: 1
      });
    };
  }
});